import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class RecordingApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.RECORDING);
  }

  createVideo(shipmentId) {
    return this.httpClient.post(`${this.getResourceUrl()}`, {
      shipment_id: shipmentId,
    });
  }

  confirmUpload(videoId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}videos/${videoId}/`,
      data,
    );
  }

  getPlaybackList(shipmentId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}shipments/${shipmentId}/`,
    );
  }
}

export default new RecordingApi();
